import { useSearchParams } from "react-router-dom";
import { PricingModal } from ".";
import { useAuthContext } from "../../auth/useAuthContext";
import { SearchParam } from "../../utils/searchParams";

export function UpgradePricingModal() {
  const { isAccountActive } = useAuthContext();
  const [searchParams, setSearchParams] = useSearchParams();

  function onClose() {
    setSearchParams(
      (params) => {
        params.delete(SearchParam.Upgrade);
        return params;
      },
      { replace: true },
    );
  }

  return (
    <PricingModal
      opened={isAccountActive && searchParams.has(SearchParam.Upgrade)}
      onClose={onClose}
    />
  );
}
